export default {
	state: {
		currentSlots: [],
		selectedSlot: undefined
	},

	mutations: {
		setCurrentSlots(store, payload) {
			store.currentSlots = payload
		},
		setSelectedSlot(store, payload) {
			store.selectedSlot = payload
		}
	},

	actions: {
		async loadCurrentSlots({ commit, dispatch }) {
			await commit('setCurrentSlots', await dispatch('apiGuestRequest', {method: 'GET', endpoint: '/slot/available/'}))
		},
		
	},

	getters: {
		currentSlots(store) {
			return store.currentSlots
		},
		selectedSlot(store) {
			return store.selectedSlot
		}
	}
}